module.exports = __webpack_public_path__ + "img/fxicon.c235251d.svg";